<template>
  <UiButton
    variant="ghost"
    color="gray"
    :aria-label="theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
    @click="toggleTheme"
  >
    <component
      :is="theme === 'dark' ? MoonIcon : SunIcon"
      class="h-6 w-6 text-gray-800 dark:text-gray-100 transition-transform"
    />
  </UiButton>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { MoonIcon, SunIcon } from '@heroicons/vue/24/solid';
import { useI18n } from 'vue-i18n';

import UiButton from '@/components/ui/UiButton.vue';

const { t } = useI18n();

// Data
const theme = ref<'light' | 'dark'>('light');

// Methods
const applyTheme = (value: 'light' | 'dark') => {
  theme.value = value;
  localStorage.setItem('theme', value);
  const html = document.documentElement;

  if (value === 'dark') {
    html.classList.add('dark');
  } else {
    html.classList.remove('dark');
  }
};

const toggleTheme = () => {
  applyTheme(theme.value === 'dark' ? 'light' : 'dark');
};

// Lifecycle
onMounted(() => {
  const saved = localStorage.getItem('theme') as 'light' | 'dark' | null;
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  applyTheme(saved || (prefersDark ? 'dark' : 'light'));
});
</script>
